import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { DownloadIcon } from 'lucide-react';
export function FinalCTA() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const goToCheckout = () => {
    window.location.href = 'https://www.legadosalud.com/cart/42499535011925:1';
  };
  return <section ref={ref} className="py-16 md:py-24 bg-gradient-to-b from-[#faf6ee] to-[#f5f0e6]" data-id="element-30">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-31">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} className="text-center" data-id="element-32">
          <h2 className="font-serif text-3xl md:text-5xl text-[#2d2d2d] mb-8" data-id="element-33">
            Recupera tu Energía y Bienestar Hoy
          </h2>

          <div className="h-px bg-gradient-to-r from-transparent via-[#c9a961] to-transparent mb-8" data-id="element-34"></div>

          <p className="text-xl md:text-2xl text-[#5d6e4f] mb-10 leading-relaxed" data-id="element-35">
            No esperes más para sentirte como la mujer que eres
          </p>

          <motion.button onClick={goToCheckout} whileHover={{
          scale: 1.05,
          y: -2
        }} whileTap={{
          scale: 0.98
        }} className="bg-[#5d6e4f] text-white px-12 py-6 rounded-lg text-xl font-semibold shadow-2xl hover:bg-[#4a5940] transition-colors inline-flex items-center gap-3" data-id="element-36">
            <DownloadIcon className="w-6 h-6" data-id="element-37" />
            DESCÁRGALO AHORA POR $6,39 USD
          </motion.button>
        </motion.div>
      </div>
    </section>;
}